//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Multiplier } from '../wheel.entity';

export default {
  name: 'WheelGameColorTabs',
  props: {
    currentColor: {
      type: Number,
      default: Multiplier.X2
    },
    x2TotalBank: {
      type: Number,
      default: 0
    },
    x3TotalBank: {
      type: Number,
      default: 0
    },
    x4TotalBank: {
      type: Number,
      default: 0
    },
    x35TotalBank: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      Multiplier
    };
  },
  methods: {
    changeColor(color) {
      this.$emit('update:currentColor', color);
      this.$emit('change-color', color);
    },
    formatCurrency(val) {
      if (val === undefined || val === null) return '$0.00';
      return `$${Number(val).toFixed(2)}`;
    }
  }
};
